// extracted by mini-css-extract-plugin
module.exports = {"quoteWrapper":"hp","quote":"hq","quoteAuthor":"hr"};